<template>
  <svg
    aria-hidden="true"
    class="h-[1.15rem] w-[1.15rem] shrink-0"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.8"
    viewBox="0 0 24 24"
  >
    <template v-if="channel === SUPPORT_CHANNEL.WHATSAPP">
      <path d="M12 21a9 9 0 1 0-8.1-5.1L3 21l5.3-.9A9 9 0 0 0 12 21Z" />
      <path
        d="M9 10.2c.4 1.8 2 3.4 3.8 3.8l.9-1.2 1.9.7v1.4c-2.9.4-6.5-3.2-6.1-6.1h1.4l.7 1.9-1.2.9Z"
        fill="currentColor"
        stroke="none"
      />
    </template>
    <template v-else-if="channel === SUPPORT_CHANNEL.EMAIL">
      <rect
        height="13"
        rx="2.5"
        width="18"
        x="3"
        y="5.5"
      />
      <path d="m3.8 7.2 7.1 5.2a2 2 0 0 0 2.2 0l7.1-5.2" />
    </template>
    <template v-else-if="channel === SUPPORT_CHANNEL.PHONE">
      <path
        d="M6.5 3.8h3l1.4 3.5-1.8 1.4a11 11 0 0 0 5.2 5.2l1.4-1.8 3.5 1.4v3a1.7 1.7 0 0 1-1.9 1.7A15.6 15.6 0 0 1 4.8 5.7 1.7 1.7 0 0 1 6.5 3.8Z"
      />
    </template>
    <template v-else-if="channel === SUPPORT_CHANNEL.PORTAL">
      <circle
        cx="12"
        cy="12"
        r="8.5"
      />
      <path d="M3.5 12h17M12 3.5c4.5 5 4.5 12 0 17-4.5-5-4.5-12 0-17Z" />
    </template>
    <!-- Anything the CRM adds later. A link is true of every channel. -->
    <template v-else>
      <path d="M10.5 13.5a3.5 3.5 0 0 0 5 0l3-3a3.5 3.5 0 0 0-5-5l-1 1" />
      <path d="M13.5 10.5a3.5 3.5 0 0 0-5 0l-3 3a3.5 3.5 0 0 0 5 5l1-1" />
    </template>
  </svg>
</template>

<script lang="ts" setup>
import { SUPPORT_CHANNEL } from '@/domains/tenant/types/consts/SupportChannel.consts'

/**
 * The channels the CRM sends today, drawn inline.
 *
 * WhatsApp, Telegram and the rest are not in the admin's Material Symbols
 * subset, and adding them would mean regenerating the icon font for four
 * glyphs — so the card owns its own.
 */
defineProps<{ channel: string }>()
</script>
